// src/components/MicrosoftSSO.js
import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../config/msalConfig';

const MicrosoftSSO = ({ onLoginSuccess, onLoginError }) => {
    const { instance } = useMsal();

    const handleMicrosoftLogin = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);

            // Extract user information from the response
            const userInfo = {
                id: response.account.homeAccountId,
                email: response.account.username,
                name: response.account.name,
                accessToken: response.accessToken,
                idToken: response.idToken,
            };

            // Call the success callback with user info
            if (onLoginSuccess) {
                onLoginSuccess(userInfo);
            }
        } catch (error) {
            console.error('Microsoft SSO login failed:', error);
            if (onLoginError) {
                onLoginError(error);
            }
        }
    };

    return (
        <button
            type="button"
            onClick={handleMicrosoftLogin}
            className="w-100 sso-button microsoft-button"
            style={{
                width: '100%',
                height: '48px',
                fontSize: '0.875rem',
                fontWeight: 600,
                borderRadius: '8px',
                border: '1px solid #DDE3E8',
                color: '#17212B',
                textTransform: 'none',
                letterSpacing: '0.2px',
                backgroundColor: '#ffffff',
                boxShadow: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                transition: 'background-color 0.18s ease, border-color 0.18s ease',
            }}
            onMouseEnter={(e) => {
                e.target.style.borderColor = '#C8D1D8';
                e.target.style.backgroundColor = '#F8FAFC';
            }}
            onMouseLeave={(e) => {
                e.target.style.borderColor = '#DDE3E8';
                e.target.style.backgroundColor = '#ffffff';
            }}
        >
            <svg width="21" height="21" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
                <path fill="#f25022" d="M0 0h11v11H0z"/>
                <path fill="#00a4ef" d="M12 0h11v11H12z"/>
                <path fill="#7fba00" d="M0 12h11v11H0z"/>
                <path fill="#ffb900" d="M12 12h11v11H12z"/>
            </svg>
            Sign in with Microsoft
        </button>
    );
};

export default MicrosoftSSO;